import { Button, Grid, LinearProgress } from '@mui/material';
import { useFormik } from 'formik';
import * as yup from 'yup';
import logo from '../../assets/logo.png';
import AppTextField from '../ui/AppTextField';
import PublicForm from '../ui/PublicForm';

const validationSchema = yup.object({
  user: yup.string().required('El usuario es requerido'),
  password: yup.string().required('La contraseña es requerida')
});

interface LoginFormProps {
  onClick: (user: string, password: string) => void;
  isLoading: boolean;
}

const LoginForm = (props: LoginFormProps) => {
  const form = useFormik({
    initialValues: {
      user: '',
      password: ''
    },
    validationSchema: validationSchema,
    onSubmit: (values) => {
      props.onClick(values.user, values.password);
    }
  });

  const buttonText = props.isLoading ? 'Iniciando sesión' : 'Iniciar sesión';

  return (
    <PublicForm
      onSubmit={form.handleSubmit}
      title="Rancho Los Robles"
      subtitle="Inicio de sesión"
      logo={logo}
    >
      <Grid>
        <AppTextField
          name="user"
          label="Usuario"
          placeholder="Usuario"
          onChange={form.handleChange}
          onBlur={form.handleBlur}
          error={form.touched.user && Boolean(form.errors.user)}
          value={form.values.user}
          helperText={form.touched.user ? form.errors.user : ''}
          disabled={props.isLoading}
        />
      </Grid>
      <Grid>
        <AppTextField
          name="password"
          label="Contraseña"
          placeholder="Contraseña"
          isPassword={true}
          onChange={form.handleChange}
          onBlur={form.handleBlur}
          error={form.touched.password && Boolean(form.errors.password)}
          value={form.values.password}
          helperText={form.touched.password ? form.errors.password : ''}
          disabled={props.isLoading}
        />
      </Grid>
      {props.isLoading && (
        <Grid>
          <LinearProgress color="secondary" />
        </Grid>
      )}
      <Grid>
        <Button
          type="submit"
          variant="contained"
          color="secondary"
          disabled={props.isLoading}
          disableElevation
          fullWidth
        >
          {buttonText}
        </Button>
      </Grid>
      {/* <Grid item sx={classes.center}>
        <span>
          {t('forgotPasswordMessage')}
          <Link component={RouterLink} to="/reset-password">
            {t('forgotPasswordLinkMessage')}
          </Link>
        </span>
      </Grid> */}
    </PublicForm>
  );
};

export default LoginForm;
